export const MIN_WIDTH_ALLOWED = 400;
export const MIN_HEIGHT_ALLOWED = 400;
export const DEFAULT_WIDTH = 1800;
export const DEFAULT_HEIGHT = 700;
export const DEFAULT_DEPTH = 300;
export const MAX_V_DOOR_WIDTH = 500;
export const DEFAULT_H_DOOR_WIDTH = 600;
export const DEFAULT_V_DOOR_WIDTH = 400;
